import axios from "axios";
import { BASE_URL, httpHeaderConfig } from "../Utils/Url";

const axiosHttp = axios.create({
  baseURL: BASE_URL,
});

axiosHttp.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    return {
      ...config,
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...config.headers,
        ...httpHeaderConfig,
      },
    };
  },
  (error) => {
    throw new Error(error?.response?.data?.message || "Error");
  }
);

export default axiosHttp;
